module.exports = __webpack_public_path__ + "img/contentImg6.a933216.png";